<template>
  <div class="section__header">
    <slot></slot>
  </div>
</template> 

<script>    
    export default {}
</script>